<div class="container" [id]="sectionHeaderId() | idGenerator: 'app-sectionHeader-'">
    <div class="leftSection">
        @if (iconName() === 'goBack') {
            <button (click)="goBack()" [attr.aria-label]="'Go back'">
                <span class="icon" [innerHTML]="svg()"></span>
            </button>
        } @else {
            @if (iconName()) {
                <span class="icon" [innerHTML]="svg()"></span>
            }
        }

        <div class="mainInfo">
            <p [class]="titleClasses()">
                {{ title() }}
            </p>
            @if (subTitle()) {
                <p class="subtitle">{{ subTitle() }}</p>
            }
        </div>
        <ng-container *ngTemplateOutlet="mainAdditionalTemplate() ?? null"></ng-container>
    </div>

    @if (infoTemplate() || actionsTemplate()) {
        <div class="rightSection" [ngClass]="{ info: infoTemplate(), actions: actionsTemplate() }">
            <ng-container *ngTemplateOutlet="infoTemplate() ?? null"></ng-container>
            <ng-container *ngTemplateOutlet="actionsTemplate() ?? null"></ng-container>
        </div>
    }
</div>
